
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetomumbaionlinecab() {



    const cardData =
    {
        keyword: 'Pune to Mumbai Online Cab Booking',
        heading: 'Mauli Cabs: Pune to Mumbai Online Cab Booking',
        headingDescription: 'Mauli Cabs offers easy and convenient Pune to Mumbai online cab booking, ensuring a hassle-free and timely journey. Whether you are booking in advance or last minute, our user-friendly online platform allows you to quickly reserve a range of vehicles including sedans, SUVs, and premium cabs. With transparent pricing, no hidden charges, and professional drivers, Mauli Cabs guarantees a smooth ride from Pune to Mumbai with a focus on punctuality and customer satisfaction.',

        top: 'Top Places to Visit in Mumbai with Mauli Cabs',

"topPlaces": [
    {
        "title": "Gateway of India",
        "description": "The Gateway of India is an iconic monument located on the waterfront in South Mumbai. Built during the 20th century, it served as a ceremonial entrance to India for Viceroys and new Governors of Bombay."
    },
    {
        "title": "Marine Drive",
        "description": "Marine Drive, also known as the Queen’s Necklace, is a 3.6-kilometer-long boulevard along the South Mumbai coast. It's a perfect place for a scenic walk and offers stunning sunset views."
    },
    {
        "title": "Elephanta Caves",
        "description": "Elephanta Caves are a network of sculpted caves located on Elephanta Island, about 11 km from the city. They feature impressive rock-cut sculptures and are a UNESCO World Heritage Site."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus",
        "description": "This UNESCO World Heritage Site is an outstanding example of Victorian Gothic Revival architecture in India, and it serves as one of Mumbai's busiest railway stations."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "The Siddhivinayak Temple is a revered Hindu temple dedicated to Lord Ganesha. Located in Prabhadevi, it attracts thousands of devotees daily seeking blessings."
    },
    {
        "title": "Colaba Causeway",
        "description": "Colaba Causeway is a vibrant shopping street lined with street stalls and boutiques selling clothes, jewelry, handicrafts, and antiques, making it a must-visit for shopaholics."
    },
    {
        "title": "Juhu Beach",
        "description": "Juhu Beach is one of Mumbai’s most famous beaches, popular for its street food, especially bhelpuri and pav bhaji, and for evening strolls along the Arabian Sea."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "Located on an islet off the coast of Worli, the Haji Ali Dargah is a mosque and tomb built in memory of a wealthy Muslim merchant who gave up his worldly possessions before making a pilgrimage to Mecca."
    },
    {
        "title": "Chowpatty Beach",
        "description": "Chowpatty Beach is famous for its lively atmosphere, street food, and being a central spot for Ganesh Chaturthi celebrations where devotees immerse Ganesh idols in the sea."
    },
    {
        "title": "Sanjay Gandhi National Park",
        "description": "Located in the northern part of Mumbai, Sanjay Gandhi National Park is a green oasis offering trekking, a mini train ride, and a chance to visit the historic Kanheri Caves."
    }
],

"services": [
    {
      "name": "Pune to Mumbai Online Cab Booking Price",
      "description": "Compare real-time prices for online cab booking from Pune to Mumbai. Choose from multiple vehicle categories like hatchback, sedan, SUV, and luxury cars with instant confirmation and no hidden costs."
    },
    {
      "name": "Pune to Mumbai Return Cab Fare",
      "description": "Get round-trip cab fare details for Pune to Mumbai travel. Includes wait time, return mileage, and options for same-day or multi-day trips with flexible scheduling."
    },
    {
      "name": "Pune to Mumbai Taxi Fare",
      "description": "Transparent taxi fare structure for Pune to Mumbai rides. Rates depend on distance, vehicle type, traffic conditions, and time of travel. Ideal for one-way or return journeys."
    },
    {
      "name": "Pune to Mumbai Affordable Fare",
      "description": "Budget-friendly cab options for travel from Pune to Mumbai. Great for solo travelers or families looking for value without compromising comfort and punctuality."
    },
    {
      "name": "Pune Mumbai Online Innova Booking",
      "description": "Book a Toyota Innova online for your Pune to Mumbai trip. Spacious seating for up to 6 passengers, air-conditioning, and ample luggage space make it a popular choice for family or corporate travel."
    },
    {
      "name": "Pune Mumbai Online Ertiga Booking",
      "description": "Online booking for Maruti Ertiga cabs from Pune to Mumbai. A cost-effective MPV option with comfortable interiors and sufficient luggage capacity for small groups or families."
    },
    {
      "name": "Pune to Mumbai Sedan Cab Booking Online",
      "description": "Book sedan cabs like Dzire or Etios for Pune to Mumbai travel. Offers a blend of comfort and affordability, perfect for business trips or airport transfers."
    },
    {
      "name": "Pune to Mumbai Ertiga Cab",
      "description": "Hire a Maruti Ertiga cab for your Pune to Mumbai journey. Ideal for 5–6 passengers, with air-conditioned interiors and reliable service at reasonable fares."
    },
    {
      "name": "Pune to Mumbai Innova Cab",
      "description": "Book a Toyota Innova cab from Pune to Mumbai for a premium and relaxed journey. Great for group travel, with added comfort and experienced drivers."
    },
    {
      "name": "Pune to Mumbai Online Innova Crysta Booking",
      "description": "Reserve an Innova Crysta cab online for your Pune to Mumbai travel. Features luxurious interiors, dual AC, and professional chauffeurs. Suitable for corporate executives and families."
    },
    {
      "name": "Toyota Innova Crysta Car Hire Pune",
      "description": "Hire a Toyota Innova Crysta in Pune for outstation travel to Mumbai. Available with or without chauffeur, with flexible packages for one-way, round-trip, or hourly usage."
    },
    {
      "name": "Toyota Innova Ertiga Car Booking",
      "description": "Book either a Toyota Innova or Maruti Ertiga based on your group size and travel preference. Both options offer reliable intercity transport from Pune to Mumbai."
    },
    {
      "name": "Pune to Mumbai Sedan Cab Service Online Booking",
      "description": "Online booking for sedan cab services from Pune to Mumbai. A balanced option offering comfort, AC, and economical pricing—ideal for daily commutes or flight pickups."
    },
    {
      "name": "Pune to Mumbai Cab Round Trip",
      "description": "Round-trip cab booking from Pune to Mumbai and back. Suitable for clients needing same-day returns or multi-day bookings, with easy rescheduling options."
    },
    {
      "name": "Best Cab Service Pune to Mumbai",
      "description": "Find the best-reviewed and top-rated cab services from Pune to Mumbai. Trained drivers, clean vehicles, GPS-enabled rides, and 24x7 customer support included."
    },
    {
      "name": "Pune to Mumbai 24x7 Online Cab Booking",
      "description": "Book cabs online anytime, day or night, for Pune to Mumbai routes. Guaranteed driver availability, instant fare confirmation, and support for emergency travel."
    },
    {
      "name": "Pune to Mumbai Airport Cab Service",
      "description": "Dedicated cab services for seamless airport transfers from Pune to Mumbai Airport. Perfect for domestic or international travelers with time-sensitive itineraries."
    },
    {
      "name": "Pune Airport to Mumbai Cab",
      "description": "Convenient cab options for passengers traveling from Pune Airport to Mumbai city or Mumbai Airport. Drivers are familiar with optimal routes and flight schedules."
    },
    {
      "name": "Pune Airport to Mumbai Airport Cab",
      "description": "Non-stop cab transfers from Pune Airport to Mumbai Airport. Ideal for connecting flights or urgent business trips, with real-time tracking and assured punctuality."
    },
    {
      "name": "Pune to Mumbai Mauli Cabs Online Cab Booking",
      "description": "Book Mauli Cabs online for travel from Pune to Mumbai. Trusted for reliable service, reasonable pricing, courteous drivers, and a fleet of well-maintained cars."
    }
  ],
  "tableData": [
    ["Pune to Mumbai Online Cab Booking Price", "Pune to Mumbai Return Cab Fare"],
    ["Pune to Mumbai Taxi Fare", "Pune to Mumbai Affordable Fare"],
    ["Pune Mumbai Online Innova Booking", "Pune Mumbai Online Ertiga Booking"],
    ["Pune to Mumbai Sedan Cab Booking Online", "Pune to Mumbai Ertiga Cab"],
    ["Pune to Mumbai Innova Cab", "Pune to Mumbai Online Innova Crysta Booking"],
    ["Toyota Innova Crysta Car Hire Pune", "Toyota Innova Ertiga Car Booking"],
    ["Pune to Mumbai Sedan Cab Service Online Booking", "Pune to Mumbai Cab Round Trip"],
    ["Best Cab Service Pune to Mumbai", "Pune to Mumbai 24x7 Online Cab Booking"],
    ["Pune to Mumbai Airport Cab Service", "Pune Airport to Mumbai Cab"],
    ["Pune Airport to Mumbai Airport Cab", "Pune to Mumbai Mauli Cabs Online Cab Booking"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Easy and Convenient Online Booking",
        "WhyChoosedescription": "Mauli Cabs offers a simple and hassle-free online cab booking process for your Pune to Mumbai journey. Book your ride in just a few clicks via our website or mobile app, and enjoy a seamless travel experience."
    },
    {
        "WhyChooseheading": "Instant Booking Confirmation",
        "WhyChoosedescription": "Once you book your Pune to Mumbai cab online, you will receive instant confirmation along with driver details, so you can relax knowing your ride is ready and waiting."
    },
    {
        "WhyChooseheading": "Variety of Vehicle Options",
        "WhyChoosedescription": "Choose from a wide range of vehicles—hatchbacks, sedans, SUVs, and luxury cars—tailored to your comfort and budget. Whether you’re traveling solo, with family, or in a group, we have the perfect ride for you."
    },
    {
        "WhyChooseheading": "Real-Time Tracking and Updates",
        "WhyChoosedescription": "Stay updated on your ride’s progress with real-time tracking. Our app provides live updates, so you can track your cab’s location and estimated arrival time at any moment."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers clear, competitive pricing with no hidden charges. Get a transparent fare estimate before confirming your booking, ensuring there are no surprises along the way."
    },
    {
        "WhyChooseheading": "24/7 Availability and Support",
        "WhyChoosedescription": "Book your Pune to Mumbai cab at any time—day or night—through our 24/7 online booking service. Our support team is always ready to assist you with any queries or modifications."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "All cabs are regularly sanitized and driven by professional, background-verified drivers. Our vehicles are equipped with safety features, providing you with a secure and comfortable ride."
    },
    {
        "WhyChooseheading": "Flexible Payment Options",
        "WhyChoosedescription": "Choose from multiple payment methods, including credit/debit cards, wallets, and cash, to settle your fare easily. Enjoy a convenient payment experience when booking your Pune to Mumbai cab online."
    }
]























    }


    const faqData = [
        {
            question: 'How do I book a cab online from Pune to Mumbai with Mauli Cabs?',
            answer: 'Booking a cab online from Pune to Mumbai is quick and easy with Mauli Cabs. Just visit our website or mobile app, enter your pickup and drop locations, select your preferred vehicle, and confirm the booking. You’ll receive instant confirmation and driver details.',
        },
        {
            question: 'Can I schedule an advance online booking for Pune to Mumbai travel?',
            answer: 'Yes, Mauli Cabs allows you to schedule your ride in advance. You can select your desired pickup date and time while booking online to ensure timely cab availability.',
        },
        {
            question: 'What types of cabs can I book online for the Pune to Mumbai route?',
            answer: 'We offer a variety of vehicles online including Hatchbacks, Sedans, SUVs, Ertiga, Innova Crysta, and luxury cars. Choose based on your group size, comfort needs, and budget.',
        },
        {
            question: 'Is it safe to book Pune to Mumbai cabs online with Mauli Cabs?',
            answer: 'Absolutely. Our online booking platform is secure and user-friendly. All bookings are confirmed with driver details, fare breakdown, and support contact information.',
        },
        {
            question: 'What payment methods are accepted for online bookings?',
            answer: 'You can pay online using debit/credit cards, UPI, net banking, or wallets. We also offer the option to pay directly to the driver in cash if preferred.',
        },
        {
            question: 'Can I modify or cancel my online cab booking?',
            answer: 'Yes, Mauli Cabs provides easy modification and cancellation options via our website or app. You can also contact customer support to make changes to your booking.',
        },
        {
            question: 'Will I receive driver and vehicle details after online booking?',
            answer: 'Yes, once your online booking is confirmed, you will receive the driver’s contact number, vehicle details, and tracking link via SMS and email for your convenience and safety.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Nilesh Jadhav",
            position: "IT Consultant",
            text: "Booked a cab online from Pune to Mumbai with Mauli Cabs. The whole process took less than two minutes and I got instant confirmation. Super smooth and reliable!",
            image: "/img/testimonial/testimonial-thumb-1-29.png",
        },
        {
            name: "Ms. Kavita Thakur",
            position: "Digital Nomad",
            text: "I loved the ease of booking a cab from my phone. Everything was transparent—from fare to driver details. Mauli Cabs is now my go-to for Pune-Mumbai trips.",
            image: "/img/testimonial/testimonial-thumb-1-30.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Mumbai Online Cab Booking | Mauli Cabs",
        "description": "Book your Pune to Mumbai cab online with Mauli Cabs for a seamless and affordable travel experience. Choose from a variety of vehicles including Innova, Ertiga, and Sedan for a comfortable journey. Our online booking system is available 24/7, ensuring a smooth ride at the best rates.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.9",
          "ratingCount": "5500"
        }
      };
      
   
      


    return (
        <div>
            <GTag/>

<Helmet>
        <title>Pune to Mumbai Online Cab Booking | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book your Pune to Mumbai cab online with Mauli Cabs. Affordable and comfortable rides, available 24x7. Choose from Innova, Ertiga, and Sedan cabs for a smooth trip. Book now!"
        />
        <meta
          name="keywords"
          content="Pune to Mumbai online cab booking price, Pune to Mumbai return cab fare, Pune to Mumbai taxi fare, affordable Pune Mumbai fare, online Innova booking Pune Mumbai, online Ertiga booking Pune Mumbai, Pune to Mumbai sedan cab booking online, Pune to Mumbai cab round trip, best cab service Pune to Mumbai, Pune to Mumbai 24x7 online cab booking, Pune to Mumbai Mauli Cabs booking"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/71.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomumbaionlinecab;